export * from './list';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/list/index.js
// module id = 706
// module chunks = 3